import { getPublicConfig } from "../api/config/getPublicConfig";
import { shouldShowPayrollTaxSavings } from "../helpers/configuration";

export const useShowPayrollTaxSavings = (totalPayrollTaxSavings?: number) => {
  const configMap = getPublicConfig();
  const showPayrollTaxStats =
    configMap.isSuccess &&
    totalPayrollTaxSavings !== undefined &&
    shouldShowPayrollTaxSavings(configMap.data, totalPayrollTaxSavings);

  return {
    showPayrollTaxStats,
    isLoading: configMap.isLoading,
    isSuccess: configMap.isSuccess,
    isError: configMap.isError,
    error: configMap.error,
  };
};
